import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom'
import AdminPanel from './views/admin/AdminPanel'
import GameScratch from './views/gamescratch'
import Login from './views/login/Login'
import PageNext from './views/pagenext'
import Presentation from './views/presentation'
import Prizedraw from './views/prizedraw'
import Register from './views/register/Register'
import SyncedRegistrations from './views/syncedregistrations/SyncedRegistrations'

type ProtectedRouteProps = {
  children: any;
}

function ProtectedRoute({ children }: ProtectedRouteProps) {
  const isAuthenticated = localStorage.getItem('isAuthenticated');

  if (!isAuthenticated) {
    // Redirecionar para a página de login se o usuário não estiver autenticado
    return <Navigate to="/login" />;
  }

  // Permitir o acesso à rota protegida se o usuário estiver autenticado
  return children;
};

export function AppRoutes() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />        
        <Route path="/presentation/*" element={<ProtectedRoute><Presentation /></ProtectedRoute>} />
        <Route path="/next/*" element={<ProtectedRoute><PageNext /></ProtectedRoute>} />
        <Route path="/register/*" element={<ProtectedRoute><Register /></ProtectedRoute>} />
        <Route path="/scratch/*" element={<ProtectedRoute><GameScratch /></ProtectedRoute>} />
        <Route path="/prizedraw/*" element={<ProtectedRoute><Prizedraw /></ProtectedRoute>} />
        <Route path="/admin/*" element={<ProtectedRoute><AdminPanel /></ProtectedRoute>} />
        <Route path="/synced-registrations" element={<ProtectedRoute><SyncedRegistrations /></ProtectedRoute>} />
        {/* Redirecionar para a página de login se nenhum path for correspondido */}
        <Route path="/" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}
